export default "__VITE_ASSET__BQPAYEsb__"